import { __extends as C, __awaiter as f, __generator as c } from "./index11.js";
import { groupBy as O } from "./index95.js";
import { ON_REMOVE_FROM_FUTURE as P } from "./index24.js";
import { ContextCancelation as k, CoreContext as E } from "./index43.js";
import { Emitter as N } from "./index23.js";
import { createTaskGroup as S } from "./index96.js";
import { attempt as q, ensure as A } from "./index67.js";
import { isOffline as M } from "./index97.js";
var j = (
  /** @class */
  function(D) {
    C(o, D);
    function o(e) {
      var t = D.call(this) || this;
      return t.criticalTasks = S(), t.plugins = [], t.failedInitializations = [], t.flushing = !1, t.queue = e, t.queue.on(P, function() {
        t.scheduleFlush(0);
      }), t;
    }
    return o.prototype.register = function(e, t, n) {
      return f(this, void 0, void 0, function() {
        var i = this;
        return c(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, Promise.resolve(t.load(e, n)).then(function() {
                i.plugins.push(t);
              }).catch(function(s) {
                if (t.type === "destination") {
                  i.failedInitializations.push(t.name), console.warn(t.name, s), e.log("warn", "Failed to load destination", {
                    plugin: t.name,
                    error: s
                  });
                  return;
                }
                throw s;
              })];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, o.prototype.deregister = function(e, t, n) {
      return f(this, void 0, void 0, function() {
        var i;
        return c(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 3, , 4]), t.unload ? [4, Promise.resolve(t.unload(e, n))] : [3, 2];
            case 1:
              r.sent(), r.label = 2;
            case 2:
              return this.plugins = this.plugins.filter(function(s) {
                return s.name !== t.name;
              }), [3, 4];
            case 3:
              return i = r.sent(), e.log("warn", "Failed to unload destination", {
                plugin: t.name,
                error: i
              }), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, o.prototype.dispatch = function(e) {
      return f(this, void 0, void 0, function() {
        var t;
        return c(this, function(n) {
          return e.log("debug", "Dispatching"), e.stats.increment("message_dispatched"), this.queue.push(e), t = this.subscribeToDelivery(e), this.scheduleFlush(0), [2, t];
        });
      });
    }, o.prototype.subscribeToDelivery = function(e) {
      return f(this, void 0, void 0, function() {
        var t = this;
        return c(this, function(n) {
          return [2, new Promise(function(i) {
            var r = function(s, h) {
              s.isSame(e) && (t.off("flush", r), i(s));
            };
            t.on("flush", r);
          })];
        });
      });
    }, o.prototype.dispatchSingle = function(e) {
      return f(this, void 0, void 0, function() {
        var t = this;
        return c(this, function(n) {
          return e.log("debug", "Dispatching"), e.stats.increment("message_dispatched"), this.queue.updateAttempts(e), e.attempts = 1, [2, this.deliver(e).catch(function(i) {
            var r = t.enqueuRetry(i, e);
            return r ? t.subscribeToDelivery(e) : (e.setFailedDelivery({ reason: i }), e);
          })];
        });
      });
    }, o.prototype.isEmpty = function() {
      return this.queue.length === 0;
    }, o.prototype.scheduleFlush = function(e) {
      var t = this;
      e === void 0 && (e = 500), !this.flushing && (this.flushing = !0, setTimeout(function() {
        t.flush().then(function() {
          setTimeout(function() {
            t.flushing = !1, t.queue.length && t.scheduleFlush(0);
          }, 0);
        });
      }, e));
    }, o.prototype.deliver = function(e) {
      return f(this, void 0, void 0, function() {
        var t, n, i, r;
        return c(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, this.criticalTasks.done()];
            case 1:
              s.sent(), t = Date.now(), s.label = 2;
            case 2:
              return s.trys.push([2, 4, , 5]), [4, this.flushOne(e)];
            case 3:
              return e = s.sent(), n = Date.now() - t, this.emit("delivery_success", e), e.stats.gauge("delivered", n), e.log("debug", "Delivered", e.event), [2, e];
            case 4:
              throw i = s.sent(), r = i, e.log("error", "Failed to deliver", r), this.emit("delivery_failure", e, r), e.stats.increment("delivery_failed"), i;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, o.prototype.enqueuRetry = function(e, t) {
      var n = !(e instanceof k) || e.retry;
      return n ? this.queue.pushWithBackoff(t) : !1;
    }, o.prototype.flush = function() {
      return f(this, void 0, void 0, function() {
        var e, t, n;
        return c(this, function(i) {
          switch (i.label) {
            case 0:
              if (this.queue.length === 0 || M())
                return [2, []];
              if (e = this.queue.pop(), !e)
                return [2, []];
              e.attempts = this.queue.getAttempts(e), i.label = 1;
            case 1:
              return i.trys.push([1, 3, , 4]), [4, this.deliver(e)];
            case 2:
              return e = i.sent(), this.emit("flush", e, !0), [3, 4];
            case 3:
              return t = i.sent(), n = this.enqueuRetry(t, e), n || (e.setFailedDelivery({ reason: t }), this.emit("flush", e, !1)), [2, []];
            case 4:
              return [2, [e]];
          }
        });
      });
    }, o.prototype.isReady = function() {
      return !0;
    }, o.prototype.availableExtensions = function(e) {
      var t = this.plugins.filter(function(a) {
        var u, v, p;
        if (a.type !== "destination" && a.name !== "Segment.io")
          return !0;
        var y = void 0;
        return (u = a.alternativeNames) === null || u === void 0 || u.forEach(function(_) {
          e[_] !== void 0 && (y = e[_]);
        }), (p = (v = e[a.name]) !== null && v !== void 0 ? v : y) !== null && p !== void 0 ? p : (a.name === "Segment.io" ? !0 : e.All) !== !1;
      }), n = O(t, "type"), i = n.before, r = i === void 0 ? [] : i, s = n.enrichment, h = s === void 0 ? [] : s, m = n.destination, g = m === void 0 ? [] : m, d = n.after, b = d === void 0 ? [] : d;
      return {
        before: r,
        enrichment: h,
        destinations: g,
        after: b
      };
    }, o.prototype.flushOne = function(e) {
      var t, n;
      return f(this, void 0, void 0, function() {
        var i, r, s, h, m, g, u, d, b, a, u, v, p, y, _;
        return c(this, function(l) {
          switch (l.label) {
            case 0:
              if (!this.isReady())
                throw new Error("Not ready");
              e.attempts > 1 && this.emit("delivery_retry", e), i = this.availableExtensions((t = e.event.integrations) !== null && t !== void 0 ? t : {}), r = i.before, s = i.enrichment, h = 0, m = r, l.label = 1;
            case 1:
              return h < m.length ? (g = m[h], [4, A(e, g)]) : [3, 4];
            case 2:
              u = l.sent(), u instanceof E && (e = u), this.emit("message_enriched", e, g), l.label = 3;
            case 3:
              return h++, [3, 1];
            case 4:
              d = 0, b = s, l.label = 5;
            case 5:
              return d < b.length ? (a = b[d], [4, q(e, a)]) : [3, 8];
            case 6:
              u = l.sent(), u instanceof E && (e = u), this.emit("message_enriched", e, a), l.label = 7;
            case 7:
              return d++, [3, 5];
            case 8:
              return v = this.availableExtensions((n = e.event.integrations) !== null && n !== void 0 ? n : {}), p = v.destinations, y = v.after, [4, new Promise(function(w, F) {
                setTimeout(function() {
                  var T = p.map(function(R) {
                    return q(e, R);
                  });
                  Promise.all(T).then(w).catch(F);
                }, 0);
              })];
            case 9:
              return l.sent(), e.stats.increment("message_delivered"), this.emit("message_delivered", e), _ = y.map(function(w) {
                return q(e, w);
              }), [4, Promise.all(_)];
            case 10:
              return l.sent(), [2, e];
          }
        });
      });
    }, o;
  }(N)
);
export {
  j as CoreEventQueue
};
//# sourceMappingURL=index71.js.map
